import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20urban%20woman%20wearing%20high%20quality%20designer%20outfit%20beige%20cream%20dress%20graceful%20pose%20luxury%20boutique%20atmosphere%20warm%20golden%20light%20sophisticated%20fashion%20editorial%20photography&width=1400&height=900&seq=hero001&orientation=landscape",
    title: "台灣設計師經典女裝",
    subtitle: "Outlet 精選",
    desc: "精選都會女性喜愛的質感服飾，以更親切的價格入手 30 年暢銷設計師品牌",
  },
  {
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20women%20fashion%20editorial%20taiwanese%20designer%20clothing%20boutique%20warm%20rose%20beige%20interior%20graceful%20sophisticated%20quality%20fabric%20soft%20natural%20light%20luxury%20atmosphere&width=1400&height=900&seq=hero002&orientation=landscape",
    title: "穿出質感與自信",
    subtitle: "經典設計更值得入手",
    desc: "修飾版型、實穿好搭，每一件都是值得珍藏的優雅之選",
  },
  {
    image: "https://readdy.ai/api/search-image?query=taiwanese%20women%20designer%20fashion%20outlet%20boutique%20elegant%20interior%20warm%20cream%20beige%20tones%20clothing%20rack%20display%20sophisticated%20minimalist%20luxury%20store%20atmosphere&width=1400&height=900&seq=hero003&orientation=landscape",
    title: "30 年口碑暢銷品牌",
    subtitle: "台中實體門市",
    desc: "台中西屯區實體門市，可預約試穿，亦可加入 LINE 線上詢問",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const goTo = (idx: number) => {
    if (idx === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 300);
  };

  const slide = slides[current];

  return (
    <section className="relative w-full h-[100vh] min-h-[620px] overflow-hidden">
      {/* Background */}
      <div
        className={`absolute inset-0 transition-opacity duration-500 ${animating ? "opacity-0" : "opacity-100"}`}
      >
        <img
          src={slide.image}
          alt="品牌主視覺"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 flex flex-col items-center justify-center h-full text-center px-6 transition-all duration-500 ${
          animating ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"
        }`}
      >
        <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-4">
          {slide.subtitle}
        </p>
        <h1 className="text-white text-[2.75rem] md:text-[3.5rem] font-bold leading-[1.3] mb-5 max-w-3xl">
          {slide.title}
        </h1>
        <p className="text-white/85 text-[1.1875rem] leading-[1.75] mb-10 max-w-xl">
          {slide.desc}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/shop"
            className="px-8 py-3.5 bg-[#faf8f5] text-[#3d2b1f] rounded-full text-[1.0625rem] font-semibold hover:bg-[#f5e6d8] transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即看新品
          </Link>
          <a
            href="https://line.me"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-8 py-3.5 border-2 border-white/60 text-white rounded-full text-[1.0625rem] font-semibold hover:bg-white/15 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-line-fill"></i>
            加入 LINE 諮詢
          </a>
          <Link
            to="/contact"
            className="px-8 py-3.5 border-2 border-white/40 text-white/90 rounded-full text-[1.0625rem] font-medium hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看門市資訊
          </Link>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`transition-all duration-300 rounded-full cursor-pointer ${
              i === current ? "w-8 h-2 bg-white" : "w-2 h-2 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 right-8 z-10 flex flex-col items-center gap-2 text-white/60">
        <span className="text-[0.8rem] tracking-widest uppercase writing-mode-vertical">Scroll</span>
        <i className="ri-arrow-down-line animate-bounce"></i>
      </div>
    </section>
  );
}
